export default "__VITE_ASSET__EJj5Dpxx__"